import { toCsv } from './csv';

const isoDate = (value) => {
  if (!value) return '';
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? '' : d.toISOString().slice(0, 16).replace('T', ' ');
};

const tagsOf = (t) => {
  if (Array.isArray(t.tags)) return t.tags.join('; ');
  return typeof t.tags === 'string' ? t.tags : '';
};

export const buildTicketColumns = (statusLabels) => [
  { label: 'Ticket #', value: (t) => t.ticket_number },
  { label: 'Subject', value: (t) => t.subject },
  { label: 'Customer', value: (t) => t.customer_name },
  { label: 'Status', value: (t) => statusLabels[t.status] || t.status },
  { label: 'Priority', value: (t) => t.priority },
  { label: 'Assigned to', value: (t) => t.assigned_user_name || 'Unassigned' },
  { label: 'Category', value: (t) => t.category },
  { label: 'Tags', value: tagsOf },
  { label: 'Created (UTC)', value: (t) => isoDate(t.created_at) },
  { label: 'Due (UTC)', value: (t) => isoDate(t.due_date) },
  { label: 'Closed (UTC)', value: (t) => isoDate(t.completed_date) }
];

export const ticketsToCsv = (tickets, statusLabels) => toCsv(tickets, buildTicketColumns(statusLabels));

export const ticketCsvFilename = (now = new Date()) => `tickets-${now.toISOString().slice(0, 10)}.csv`;
